import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const sunCityCenterConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Sun City Center Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Sun City Center, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_sun_city_center',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Sun City Center',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Sun City Center Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we provide respectful, professional 
     tree care to homeowners throughout <strong>Sun City Center</strong>. This 
     active 55+ community takes great pride in beautifully maintained properties 
     and keeping trees safe and well trimmed is a key part of that. When a tree 
     develops a hazardous overhang, sustains storm damage, or needs full removal, 
     our team handles it with efficiency and care for your home and landscape.`,

    `We specialize in <strong>hazardous tree removal and precision trimming for 
     residential communities</strong> large limb overhangs near homes and 
     lanais, storm damaged trees, palms and hardwoods that have outgrown 
     their space near structures, and full removals executed cleanly without 
     disrupting your property or your neighbors.`,

    `<strong>Sam's Tree Service</strong> delivers trusted, affordable tree care 
     throughout <strong>Sun City Center</strong> and the surrounding 
     <strong>South Hillsborough</strong> area giving you the peace of mind 
     that your property is safe and well cared for all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Sun City Center, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_SunCityCenter = () => <LocationPage config={sunCityCenterConfig} />;
export default Services_SunCityCenter;
